"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
// import '@ant-design/compatible/assets/index.css';
var antd_1 = require("antd");
var react_intl_1 = require("react-intl");
var formLayout_1 = require("../../consts/formLayout");
var FileUploadUtility_1 = require("../../../utils/FileUploadUtility");
var translationMessages = react_intl_1.defineMessages({
    attachment_labels_Reference: {
        id: "attachment_labels_Reference",
        defaultMessage: "Reference",
    },
    attachment_labels_Reference_requiredMessage: {
        id: "attachment_labels_Reference_requiredMessage",
        defaultMessage: "Please input the reference",
    },
    attachment_labels_Description: {
        id: "attachment_labels_Description",
        defaultMessage: "Description",
    },
    attachment_labels_Description_requiredMessage: {
        id: "attachment_labels_Description_requiredMessage",
        defaultMessage: "Please input the description",
    },
    attachment_labels_File: {
        id: "attachment_labels_File",
        defaultMessage: "File",
    },
    attachment_labels_uploadFileMsg: {
        id: "attachment_labels_uploadFileMsg",
        defaultMessage: "Click or drag file to this area to upload",
    },
    attachment_labels_descriptionErrorMsg: {
        id: "attachment_labels_descriptionErrorMsg",
        defaultMessage: "Description must not match to another file description",
    },
    attachment_error_fileTooLarge: {
        id: "attachment_error_fileTooLarge",
        defaultMessage: "File size must be less than {uploadSizeLimit}KB",
    },
    attachment_error_fileWrongType: {
        id: "attachment_error_fileWrongType",
        defaultMessage: "Wrong file type",
    },
    attachment_error_fileFailedToUpload: {
        id: "attachment_error_fileFailedToUpload",
        defaultMessage: "File failed to upload",
    },
});
var Attachment = function (props) {
    var fieldName = props.fieldName;
    var handleRemoveFile = function () {
        props.setFile([]);
        props.setAttachmentFieldValidation("");
    };
    var normFile = function (e) {
        if (Array.isArray(e)) {
            return e;
        }
        props.setFile(e && e.fileList);
        return e && e.fileList;
    };
    var returnOtherFieldNames = function (fn) {
        switch (fn) {
            case "file1":
                return ["file2", "file3"];
            case "file2":
                return ["file1", "file3"];
            case "file3":
                return ["file1", "file2"];
        }
    };
    var attachmentLabelsDescriptionErrorMsg = props.intl.formatMessage(translationMessages.attachment_labels_descriptionErrorMsg);
    var verifyTheAttachment = function (info, uploadSizeLimit, formInstance) {
        if (info.file.status === "removed")
            return;
        props.setAttachmentFieldValidation("validating");
        var ifFileIsValid = FileUploadUtility_1.reportIfFileIsValid(info.file, uploadSizeLimit, {
            uploadErrorToLarge: props.intl.formatMessage(translationMessages.attachment_error_fileTooLarge, { uploadSizeLimit: uploadSizeLimit / 1024 }),
            uploadErrorWrongType: props.intl.formatMessage(translationMessages.attachment_error_fileWrongType),
            uploadFailed: props.intl.formatMessage(translationMessages.attachment_error_fileFailedToUpload),
        });
        if (!ifFileIsValid) {
            formInstance.resetFields(["attachments", "" + props.fieldName, "file"]);
            props.setAttachmentFieldValidation("error");
            props.setFile([]);
        }
        else {
            props.setAttachmentFieldValidation("success");
            props.setFile([info.file]);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(antd_1.Form.Item, __assign({}, formLayout_1.formItemVerticalLayout, { label: props.intl.formatMessage(translationMessages.attachment_labels_File), name: ["attachments", "" + fieldName, "file"], valuePropName: "fileList", getValueFromEvent: normFile, validateStatus: props.attachmentFieldValidation }),
            React.createElement(antd_1.Upload.Dragger, { name: "attachment:" + fieldName, multiple: false, onRemove: handleRemoveFile, onChange: function (info) {
                    verifyTheAttachment(info, props.uploadSizeLimit, props.formInstance);
                }, beforeUpload: function (file) { return false; }, fileList: props.file },
                React.createElement("p", null, props.intl.formatMessage(translationMessages.attachment_labels_uploadFileMsg)))),
        React.createElement(antd_1.Form.Item, __assign({}, formLayout_1.formItemVerticalLayout, { label: props.intl.formatMessage(translationMessages.attachment_labels_Description), name: ["attachments", "" + fieldName, "description"], rules: [
                {
                    required: props.file.length > 0,
                    message: props.intl.formatMessage(translationMessages.attachment_labels_Description_requiredMessage),
                },
                function (_a) {
                    var getFieldValue = _a.getFieldValue;
                    return ({
                        validator: function (rule, value) {
                            if (!value || getFieldValue(["attachments", returnOtherFieldNames(fieldName)[0], "description"]) !== value) {
                                return Promise.resolve();
                            }
                            return Promise.reject(attachmentLabelsDescriptionErrorMsg);
                        }
                    });
                },
                function (_a) {
                    var getFieldValue = _a.getFieldValue;
                    return ({
                        validator: function (rule, value) {
                            if (!value || getFieldValue(["attachments", returnOtherFieldNames(fieldName)[1], "description"]) !== value) {
                                return Promise.resolve();
                            }
                            return Promise.reject(attachmentLabelsDescriptionErrorMsg);
                        }
                    });
                },
            ] }),
            React.createElement(antd_1.Input, null))));
};
exports.default = react_intl_1.injectIntl(React.memo(Attachment));
